<template>
    <div>
        <parameters
                ref="params"
                @input="onInput"
        ></parameters>
        <report
                :url="url"
                v-if="hasParams"
                v-show="isDataLoaded"
                :params="params"
                @success="onSuccess"
                @validation-error="onError"
        ></report>
    </div>
</template>

<script>
  import Report from './table';
  import Parameters from './parameters';

  export default {
    components: {
      Report,
      Parameters,
    },

    props: {
      url: null,
    },

    data() {
      return {
        params: null,
        isDataLoaded: false,
      }
    },

    computed: {
      /**
       * @return {Boolean}
       */
      hasParams() {
        return Boolean(this.params);
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      onInput(params) {
        this.params = params;
      },

      /**
       * @return {undefined}
       */
      onSuccess() {
        this.$refs.params.setErrors({});
        this.isDataLoaded = true;
      },

      /**
       * @param {objects} errors
       */
      onError(errors) {
        this.$refs.params.setErrors(errors);
        this.isDataLoaded = false;
      },
    },
  }
</script>
